module.exports=[
  {
    "date": 1999,
    "Darkhan-Uul": 0.18266715,
    "Dornogovi": 0.51771117,
    "Dundgovi": 0.82518736,
    "Govisumber": 0.3859174,
    "Omnogovi": 0.74271469,
    "Selenge": 0.45498378,
    "To'v": 0.73018022,
    "Dornod": 0.49259367,
    "Hentii": 0.63369397,
    "Sukhbaatar": 0.79029734,
    "Ulaanbaatar": 0.04644299,
    "Arxangai": 0.92392195,
    "Bayankhongor": 0.81386331,
    "Bulgan": 0.77202308,
    "Khovsgol": 0.81695246,
    "Orkhon": 0.11770136,
    "Ovorkhangai": 0.86406901,
    "Bayan-Olgii": 0.79346134,
    "Govi-Altai": 0.86036767,
    "Khovd": 0.73569933,
    "Uvs": 0.81548235,
    "Zavkhan": 0.81138625,
    "Mongolia": 0.49884597
  },
  {
    "date": 2000,
    "Darkhan-Uul": 0.20648649,
    "Dornogovi": 0.52525928,
    "Dundgovi": 0.79241964,
    "Govisumber": 0.34875691,
    "Omnogovi": 0.71711433,
    "Selenge": 0.48030519,
    "To'v": 0.70909705,
    "Dornod": 0.50796409,
    "Hentii": 0.60806949,
    "Sukhbaatar": 0.79566563,
    "Ulaanbaatar": 0.04623731,
    "Arxangai": 0.8956739,
    "Bayankhongor": 0.80204697,
    "Bulgan": 0.73943883,
    "Khovsgol": 0.78797094,
    "Orkhon": 0.14842622,
    "Ovorkhangai": 0.79860287,
    "Bayan-Olgii": 0.74020668,
    "Govi-Altai": 0.81949059,
    "Khovd": 0.73007295,
    "Uvs": 0.75604693,
    "Zavkhan": 0.75618407,
    "Mongolia": 0.48508096
  },
  {
    "date": 2001,
    "Darkhan-Uul": 0.19253298,
    "Dornogovi": 0.48548466,
    "Dundgovi": 0.76153419,
    "Govisumber": 0.28552457,
    "Omnogovi": 0.70602348,
    "Selenge": 0.45972335,
    "To'v": 0.67160999,
    "Dornod": 0.46464056,
    "Hentii": 0.59292189,
    "Sukhbaatar": 0.77619267,
    "Ulaanbaatar": 0.0439581,
    "Arxangai": 0.84603957,
    "Bayankhongor": 0.7529202,
    "Bulgan": 0.74794886,
    "Khovsgol": 0.73376602,
    "Orkhon": 0.12571998,
    "Ovorkhangai": 0.74403848,
    "Bayan-Olgii": 0.73830172,
    "Govi-Altai": 0.75825098,
    "Khovd": 0.69934957,
    "Uvs": 0.73902775,
    "Zavkhan": 0.72719531,
    "Mongolia": 0.45844427
  },
  {
    "date": 2002,
    "Darkhan-Uul": 0.14540384,
    "Dornogovi": 0.43917054,
    "Dundgovi": 0.75407991,
    "Govisumber": 0.25170914,
    "Omnogovi": 0.64095005,
    "Selenge": 0.42373255,
    "To'v": 0.63559679,
    "Dornod": 0.4670378,
    "Hentii": 0.57263929,
    "Sukhbaatar": 0.79066207,
    "Ulaanbaatar": 0.04081034,
    "Arxangai": 0.82880869,
    "Bayankhongor": 0.63241848,
    "Bulgan": 0.7039677,
    "Khovsgol": 0.69674677,
    "Orkhon": 0.11440213,
    "Ovorkhangai": 0.72777424,
    "Bayan-Olgii": 0.72313481,
    "Govi-Altai": 0.67880142,
    "Khovd": 0.65869786,
    "Uvs": 0.7181901,
    "Zavkhan": 0.68451075,
    "Mongolia": 0.42775115
  },
  {
    "date": 2003,
    "Darkhan-Uul": 0.13625062,
    "Dornogovi": 0.41081408,
    "Dundgovi": 0.738437,
    "Govisumber": 0.27129338,
    "Omnogovi": 0.6076847,
    "Selenge": 0.37369142,
    "To'v": 0.59422969,
    "Dornod": 0.45318813,
    "Hentii": 0.55954007,
    "Sukhbaatar": 0.78251727,
    "Ulaanbaatar": 0.03545254,
    "Arxangai": 0.81023022,
    "Bayankhongor": 0.61875784,
    "Bulgan": 0.67034036,
    "Khovsgol": 0.66696754,
    "Orkhon": 0.09017133,
    "Ovorkhangai": 0.69807726,
    "Bayan-Olgii": 0.74932193,
    "Govi-Altai": 0.66983122,
    "Khovd": 0.64490984,
    "Uvs": 0.70991865,
    "Zavkhan": 0.70313272,
    "Mongolia": 0.40333101
  },
  {
    "date": 2004,
    "Darkhan-Uul": 0.13083541,
    "Dornogovi": 0.39825669,
    "Dundgovi": 0.72483545,
    "Govisumber": 0.27322404,
    "Omnogovi": 0.58823529,
    "Selenge": 0.34858291,
    "To'v": 0.58049604,
    "Dornod": 0.41220255,
    "Hentii": 0.52453469,
    "Sukhbaatar": 0.75015124,
    "Ulaanbaatar": 0.03347964,
    "Arxangai": 0.79255516,
    "Bayankhongor": 0.62555602,
    "Bulgan": 0.62630903,
    "Khovsgol": 0.65339262,
    "Orkhon": 0.07319573,
    "Ovorkhangai": 0.70280348,
    "Bayan-Olgii": 0.74778661,
    "Govi-Altai": 0.67069126,
    "Khovd": 0.62195248,
    "Uvs": 0.71723716,
    "Zavkhan": 0.69270598,
    "Mongolia": 0.38470825
  },
  {
    "date": 2005,
    "Darkhan-Uul": 0.11286986,
    "Dornogovi": 0.3593929,
    "Dundgovi": 0.71982895,
    "Govisumber": 0.26810478,
    "Omnogovi": 0.56727614,
    "Selenge": 0.34290091,
    "To'v": 0.55429233,
    "Dornod": 0.38535965,
    "Hentii": 0.50331643,
    "Sukhbaatar": 0.73018967,
    "Ulaanbaatar": 0.03017703,
    "Arxangai": 0.78060636,
    "Bayankhongor": 0.64294244,
    "Bulgan": 0.61534363,
    "Khovsgol": 0.66194571,
    "Orkhon": 0.07331097,
    "Ovorkhangai": 0.68315216,
    "Bayan-Olgii": 0.72674419,
    "Govi-Altai": 0.65662767,
    "Khovd": 0.62070028,
    "Uvs": 0.70909091,
    "Zavkhan": 0.6824226,
    "Mongolia": 0.36887137
  },
  {
    "date": 2006,
    "Darkhan-Uul": 0.10749834,
    "Dornogovi": 0.29487353,
    "Dundgovi": 0.69835035,
    "Govisumber": 0.25,
    "Omnogovi": 0.56382392,
    "Selenge": 0.32641582,
    "To'v": 0.55687649,
    "Dornod": 0.37023106,
    "Hentii": 0.48908061,
    "Sukhbaatar": 0.70528033,
    "Ulaanbaatar": 0.02917405,
    "Arxangai": 0.77171074,
    "Bayankhongor": 0.64954826,
    "Bulgan": 0.60461779,
    "Khovsgol": 0.62715585,
    "Orkhon": 0.06824696,
    "Ovorkhangai": 0.66217003,
    "Bayan-Olgii": 0.70772958,
    "Govi-Altai": 0.66692293,
    "Khovd": 0.63553565,
    "Uvs": 0.6960199,
    "Zavkhan": 0.67396882,
    "Mongolia": 0.3563117
  },
  {
    "date": 2007,
    "Darkhan-Uul": 0.09879539,
    "Dornogovi": 0.2849826,
    "Dundgovi": 0.68233629,
    "Govisumber": 0.20710059,
    "Omnogovi": 0.55219365,
    "Selenge": 0.33887734,
    "To'v": 0.5447345,
    "Dornod": 0.35303306,
    "Hentii": 0.48694726,
    "Sukhbaatar": 0.67185341,
    "Ulaanbaatar": 0.02960685,
    "Arxangai": 0.763011,
    "Bayankhongor": 0.63662804,
    "Bulgan": 0.60551288,
    "Khovsgol": 0.62589569,
    "Orkhon": 0.06543461,
    "Ovorkhangai": 0.67047363,
    "Bayan-Olgii": 0.71415085,
    "Govi-Altai": 0.68817912,
    "Khovd": 0.62916434,
    "Uvs": 0.70283848,
    "Zavkhan": 0.6715471,
    "Mongolia": 0.3502142
  },
  {
    "date": 2008,
    "Darkhan-Uul": 0.1020449,
    "Dornogovi": 0.26260243,
    "Dundgovi": 0.65990628,
    "Govisumber": 0.19577134,
    "Omnogovi": 0.5315568,
    "Selenge": 0.34377504,
    "To'v": 0.54515024,
    "Dornod": 0.33727143,
    "Hentii": 0.47050382,
    "Sukhbaatar": 0.61080711,
    "Ulaanbaatar": 0.02383241,
    "Arxangai": 0.74376526,
    "Bayankhongor": 0.63001963,
    "Bulgan": 0.60762165,
    "Khovsgol": 0.61671872,
    "Orkhon": 0.06735991,
    "Ovorkhangai": 0.65167955,
    "Bayan-Olgii": 0.70096733,
    "Govi-Altai": 0.69894598,
    "Khovd": 0.62795442,
    "Uvs": 0.68286805,
    "Zavkhan": 0.67979763,
    "Mongolia": 0.33573435
  },
  {
    "date": 2009,
    "Darkhan-Uul": 0.10109179,
    "Dornogovi": 0.25859056,
    "Dundgovi": 0.63321747,
    "Govisumber": 0.1761583,
    "Omnogovi": 0.50072093,
    "Selenge": 0.33310842,
    "To'v": 0.53715686,
    "Dornod": 0.31515265,
    "Hentii": 0.43664996,
    "Sukhbaatar": 0.59772234,
    "Ulaanbaatar": 0.02152411,
    "Arxangai": 0.72295267,
    "Bayankhongor": 0.61717663,
    "Bulgan": 0.594911,
    "Khovsgol": 0.58546259,
    "Orkhon": 0.05942379,
    "Ovorkhangai": 0.61485672,
    "Bayan-Olgii": 0.70248906,
    "Govi-Altai": 0.65637066,
    "Khovd": 0.61804147,
    "Uvs": 0.65903867,
    "Zavkhan": 0.6442862,
    "Mongolia": 0.31632011
  },
  {
    "date": 2010,
    "Darkhan-Uul": 0.10691602,
    "Dornogovi": 0.25061812,
    "Dundgovi": 0.55148182,
    "Govisumber": 0.17253439,
    "Omnogovi": 0.42763158,
    "Selenge": 0.32903998,
    "To'v": 0.52374695,
    "Dornod": 0.2907489,
    "Hentii": 0.43482371,
    "Sukhbaatar": 0.58956477,
    "Ulaanbaatar": 0.01861312,
    "Arxangai": 0.68652654,
    "Bayankhongor": 0.58254523,
    "Bulgan": 0.57726677,
    "Khovsgol": 0.5648768,
    "Orkhon": 0.05712172,
    "Ovorkhangai": 0.55045028,
    "Bayan-Olgii": 0.66969463,
    "Govi-Altai": 0.60638908,
    "Khovd": 0.59313267,
    "Uvs": 0.63804987,
    "Zavkhan": 0.61507047,
    "Mongolia": 0.29176557
  },
  {
    "date": 2011,
    "Darkhan-Uul": 0.09823885,
    "Dornogovi": 0.24732293,
    "Dundgovi": 0.5385724,
    "Govisumber": 0.1792432,
    "Omnogovi": 0.38988409,
    "Selenge": 0.31817086,
    "To'v": 0.51708115,
    "Dornod": 0.28785183,
    "Hentii": 0.4082397,
    "Sukhbaatar": 0.57905753,
    "Ulaanbaatar": 0.01668867,
    "Arxangai": 0.66739813,
    "Bayankhongor": 0.56054771,
    "Bulgan": 0.55470857,
    "Khovsgol": 0.55199261,
    "Orkhon": 0.05988266,
    "Ovorkhangai": 0.52329117,
    "Bayan-Olgii": 0.66015718,
    "Govi-Altai": 0.59497009,
    "Khovd": 0.56176485,
    "Uvs": 0.61821304,
    "Zavkhan": 0.60067131,
    "Mongolia": 0.27863643
  },
  {
    "date": 2012,
    "Darkhan-Uul": 0.09199085,
    "Dornogovi": 0.25657784,
    "Dundgovi": 0.52677082,
    "Govisumber": 0.17450251,
    "Omnogovi": 0.37124909,
    "Selenge": 0.3048681,
    "To'v": 0.51461966,
    "Dornod": 0.26582915,
    "Hentii": 0.40037689,
    "Sukhbaatar": 0.57613864,
    "Ulaanbaatar": 0.01553617,
    "Arxangai": 0.65093557,
    "Bayankhongor": 0.55476481,
    "Bulgan": 0.55501166,
    "Khovsgol": 0.53274875,
    "Orkhon": 0.05441767,
    "Ovorkhangai": 0.53872537,
    "Bayan-Olgii": 0.65348736,
    "Govi-Altai": 0.60745211,
    "Khovd": 0.54025741,
    "Uvs": 0.61426052,
    "Zavkhan": 0.59039108,
    "Mongolia": 0.27051153
  },
  {
    "date": 2013,
    "Darkhan-Uul": 0.08872644,
    "Dornogovi": 0.254177,
    "Dundgovi": 0.53237464,
    "Govisumber": 0.18632479,
    "Omnogovi": 0.35730253,
    "Selenge": 0.3029496,
    "To'v": 0.51394948,
    "Dornod": 0.26740556,
    "Hentii": 0.40795314,
    "Sukhbaatar": 0.55821605,
    "Ulaanbaatar": 0.01447902,
    "Arxangai": 0.64381453,
    "Bayankhongor": 0.55900151,
    "Bulgan": 0.55490341,
    "Khovsgol": 0.50918742,
    "Orkhon": 0.05225268,
    "Ovorkhangai": 0.5427038,
    "Bayan-Olgii": 0.66600538,
    "Govi-Altai": 0.60341507,
    "Khovd": 0.53496944,
    "Uvs": 0.59462663,
    "Zavkhan": 0.58989879,
    "Mongolia": 0.26436928
  },
  {
    "date": 2014,
    "Darkhan-Uul": 0.08824159,
    "Dornogovi": 0.25144644,
    "Dundgovi": 0.54134444,
    "Govisumber": 0.20004211,
    "Omnogovi": 0.35026641,
    "Selenge": 0.30858855,
    "To'v": 0.51273919,
    "Dornod": 0.27333185,
    "Hentii": 0.40368472,
    "Sukhbaatar": 0.55842676,
    "Ulaanbaatar": 0.01413217,
    "Arxangai": 0.64228431,
    "Bayankhongor": 0.54953332,
    "Bulgan": 0.5535195,
    "Khovsgol": 0.50715961,
    "Orkhon": 0.04000308,
    "Ovorkhangai": 0.53769499,
    "Bayan-Olgii": 0.65325064,
    "Govi-Altai": 0.59736475,
    "Khovd": 0.53578208,
    "Uvs": 0.58786621,
    "Zavkhan": 0.58453281,
    "Mongolia": 0.25912059
  },
  {
    "date": 2015,
    "Darkhan-Uul": 0.08034433,
    "Dornogovi": 0.2507743,
    "Dundgovi": 0.54071942,
    "Govisumber": 0.19812637,
    "Omnogovi": 0.34645238,
    "Selenge": 0.32084868,
    "To'v": 0.5137307,
    "Dornod": 0.27674987,
    "Hentii": 0.40338103,
    "Sukhbaatar": 0.55022897,
    "Ulaanbaatar": 0.01364171,
    "Arxangai": 0.64960527,
    "Bayankhongor": 0.54969582,
    "Bulgan": 0.55939174,
    "Khovsgol": 0.50332248,
    "Orkhon": 0.03848482,
    "Ovorkhangai": 0.53708356,
    "Bayan-Olgii": 0.63296075,
    "Govi-Altai": 0.5973121,
    "Khovd": 0.5233576,
    "Uvs": 0.57231756,
    "Zavkhan": 0.58854796,
    "Mongolia": 0.25227853
  },
  {
    "date": 2016,
    "Darkhan-Uul": 0.08309798,
    "Dornogovi": 0.25326371,
    "Dundgovi": 0.5625,
    "Govisumber": 0.2033147,
    "Omnogovi": 0.34699308,
    "Selenge": 0.32400664,
    "To'v": 0.51539253,
    "Dornod": 0.28472818,
    "Hentii": 0.41834847,
    "Sukhbaatar": 0.56101589,
    "Ulaanbaatar": 0.01383827,
    "Arxangai": 0.6561106,
    "Bayankhongor": 0.55705464,
    "Bulgan": 0.56484487,
    "Khovsgol": 0.5107061,
    "Orkhon": 0.04008514,
    "Ovorkhangai": 0.55217651,
    "Bayan-Olgii": 0.63667702,
    "Govi-Altai": 0.61092654,
    "Khovd": 0.53061411,
    "Uvs": 0.58481437,
    "Zavkhan": 0.61343581,
    "Mongolia": 0.2572412
  },
  {
    "date": 2017,
    "Darkhan-Uul": 0.08399429,
    "Dornogovi": 0.24952025,
    "Dundgovi": 0.56904369,
    "Govisumber": 0.19407159,
    "Omnogovi": 0.34862299,
    "Selenge": 0.31903584,
    "To'v": 0.50797092,
    "Dornod": 0.29279242,
    "Hentii": 0.4249747,
    "Sukhbaatar": 0.55945571,
    "Ulaanbaatar": 0.0133189,
    "Arxangai": 0.66823956,
    "Bayankhongor": 0.55447278,
    "Bulgan": 0.55898509,
    "Khovsgol": 0.51607908,
    "Orkhon": 0.04239827,
    "Ovorkhangai": 0.55470693,
    "Bayan-Olgii": 0.63387793,
    "Govi-Altai": 0.61719413,
    "Khovd": 0.52469736,
    "Uvs": 0.59226464,
    "Zavkhan": 0.61334637,
    "Mongolia": 0.25851391
  },
  {
    "date": 2018,
    "Darkhan-Uul": 0.07756614,
    "Dornogovi": 0.2484262,
    "Dundgovi": 0.56960237,
    "Govisumber": 0.1876392,
    "Omnogovi": 0.34103731,
    "Selenge": 0.31517445,
    "To'v": 0.50283523,
    "Dornod": 0.29712447,
    "Hentii": 0.43238519,
    "Sukhbaatar": 0.55944822,
    "Ulaanbaatar": 0.01214599,
    "Arxangai": 0.67211235,
    "Bayankhongor": 0.55417933,
    "Bulgan": 0.56014052,
    "Khovsgol": 0.51577987,
    "Orkhon": 0.04074726,
    "Ovorkhangai": 0.5543403,
    "Bayan-Olgii": 0.61342878,
    "Govi-Altai": 0.61725809,
    "Khovd": 0.51861086,
    "Uvs": 0.58951331,
    "Zavkhan": 0.60885931,
    "Mongolia": 0.25808276
  }
]